<template>
  <div class="t-contacts-modal">
    <h3 class="t-certificates-modal__name">{{ props.title }}</h3>
    <select-custom-cmp class="t-contacts-modal__select" :data="select" ref="selectCity"></select-custom-cmp>
    <div class="t-contacts-modal__bg" :class="{ _visible: cities.length > 16 }">
      <div class="t-contacts-modal__wrap">
        <div class="t-contacts-modal__content" :style="'height:' + Math.ceil(cities.length / 2) * 34 + 'px;'">
          <!-- 34 - высота одного t-contacts-modal__item -->
          <div
            v-for="item in cities"
            @click="setCity(item)"
            class="t-contacts-modal__item"
            :class="{ _active: activeCityId === item.id && activeCountryIdGlobal === item.countryId }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import selectCustom from '@components/ui-components/select-custom/select-custom'
import Vue from 'vue'

export default {
  props: ['props'],
  data() {
    return {
      select: {
        name: 'cityModal',
        value: [],
        placeholder: '',
        error: false,
        valid: false,
        list: [],
      },
      countries: [],
      cities: [],
      activeCityId: undefined,
      activeCountryId: undefined,
      activeCountryIdGlobal: undefined,
    }
  },
  components: {
    'select-custom-cmp': selectCustom,
  },
  methods: {
    ...mapActions('modal', ['modalClose']),
    setCity(item) {
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, {
            cityId: item.id,
            countryId: this.activeCountryId,
          }),
        })
        .catch(err => {})
      this.modalClose()
    },
    ajaxCities() {
      let url = process.env.NODE_ENV !== 'production' ? 'cities.json' : 'cities'
      let method = process.env.NODE_ENV !== 'production' ? 'get' : 'post'
      Vue.http[method](url, { countryId: this.activeCountryId })
        .then(response => response.json())
        .then(data => {
          this.cities = data.data
          if (this.activeCityId === undefined && this.cities[0]) {
            this.activeCityId = this.cities[0].id
          }
        })
    },
    countryId(data) {
      this.activeCountryId = data
    },
  },
  watch: {
    'select.value': function() {
      this.countries.forEach(item => {
        if (item.label.indexOf(this.select.value[0].label) > -1) {
          this.activeCountryId = item.id
        }
      })
    },
  },
  created() {
    // определяем выбранную страну и город по урлу
    if (this.$route.query.cityId) {
      this.activeCityId = this.$route.query.cityId
    }
    this.activeCountryIdGlobal = this.props.countryId

    let url = process.env.NODE_ENV !== 'production' ? 'countries.json' : 'countries'
    Vue.http
      .get(url)
      .then(response => response.json())
      .then(data => {
        this.select.list = data.data
        this.countries = data.data
        if (this.activeCountryIdGlobal) {
          data.data.forEach(item => {
            if (item.id.toString().indexOf(this.activeCountryIdGlobal) > -1) {
              this.activeCountryId = item.id
              this.select.value.push(item)
              this.$refs.selectCity.listCreated()
              this.$refs.selectCity.valueCreated()
              this.$refs.selectCity.setValue(item)
            }
          })
        } else {
          this.select.value.push(this.select.list[0])
          this.$refs.selectCity.listCreated()
          this.$refs.selectCity.valueCreated()
          this.$refs.selectCity.setValue(this.select.list[0])
          this.activeCountryId = data.data[0].id
          this.activeCountryIdGlobal = data.data[0].id
        }
      })
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/contacts.vue